import { CartUpdatedEvent } from '@theme/events';

// MIMOYA : Shipping Protection — ajout automatique + interrupteur dans le panier tiroir.
// Le produit est masque des lignes du panier (voir sections/cart-drawer.liquid) ;
// cette ligne le represente avec un interrupteur. Refus memorise pour la session.
class MimoyaShippingProtection extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('[data-ref="protection-toggle"]');
    this.clickHandler = this.#onToggle.bind(this);
    this.toggle?.addEventListener('click', this.clickHandler);
    this.#init();
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.clickHandler);
  }

  #onToggle() {
    const on = this.dataset.inCart === 'true';
    this.#remember(on);
    this.#set(!on);
  }

  #init() {
    const inCart = this.dataset.inCart === 'true';
    const hasItems = this.dataset.hasItems === 'true';

    if (inCart && !hasItems) {
      // Il ne reste que la protection dans le panier : on la retire.
      this.#set(false);
      return;
    }

    if (inCart && Number(this.dataset.quantity) > 1) {
      // Jamais plus d'une protection : quantité ramenée à 1.
      this.#set(true);
      return;
    }

    if (!inCart && hasItems && this.dataset.defaultOn === 'true' && !this.#optedOut()) {
      this.#set(true);
    }
  }

  #optedOut() {
    try {
      return sessionStorage.getItem('mimoya-protection-off') === '1';
    } catch (e) {
      return false;
    }
  }

  #remember(off) {
    try {
      if (off) {
        sessionStorage.setItem('mimoya-protection-off', '1');
      } else {
        sessionStorage.removeItem('mimoya-protection-off');
      }
    } catch (e) {
      // Stockage indisponible : la protection suivra simplement le defaut.
    }
  }

  async #set(on) {
    if (window.mimoyaProtectionBusy) return;
    window.mimoyaProtectionBusy = true;

    const sectionId = this.closest('cart-drawer')?.dataset.sectionId;
    const sections = [sectionId, 'auto-gifts'].filter(Boolean).join(',');
    const updates = {};
    updates[this.dataset.variantId] = on ? 1 : 0;

    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections, sections_url: window.location.pathname }),
      });
      const cart = await response.json();
      if (cart.errors) return;

      document.dispatchEvent(
        new CartUpdatedEvent(
          {},
          {
            itemCount: cart.item_count,
            source: 'mimoya-shipping-protection',
            sections: cart.sections,
          },
        ),
      );
    } catch (e) {
      console.error('MIMOYA Shipping Protection:', e);
    } finally {
      window.mimoyaProtectionBusy = false;
    }
  }
}

if (!customElements.get('mimoya-shipping-protection')) {
  customElements.define('mimoya-shipping-protection', MimoyaShippingProtection);
}
